import { EntityRepository, Repository } from "typeorm";
import {  RmRack } from "../rm-racks.entity";

@EntityRepository(RmRack)
export class RmRackRepository extends Repository<RmRack>{
}